module.exports = "/images/logo-footer.svg?1cc8c5bcff5723190aa35b63d7967c58";